<p>amende-detail works!</p>
